import { render, staticRenderFns } from "./NewReceipt.vue?vue&type=template&id=06ae5ef8&scoped=true"
import script from "./NewReceipt.vue?vue&type=script&lang=js"
export * from "./NewReceipt.vue?vue&type=script&lang=js"
import style1 from "./NewReceipt.vue?vue&type=style&index=1&id=06ae5ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae5ef8",
  null
  
)

export default component.exports